import React from 'react';
import { useSelector } from 'react-redux';
import { CartEmpty } from '@yme/assets/icons';
import { InfiniteScroll } from '@yme/atoms/infinite-scroll';
import { InfoBlockEmptyResults } from '@yme/atoms/info-block-empty-results';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/index';
import { useWishlist } from '@yme/hooks/useWishlist';
import { AccessoriesCard } from '@yme/molecules/cards';
import { getRootLang } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey } from '@yme/utils/common';
import { getProductCardData } from '@yme/utils/product';
import { FilterResultSkeleton } from './FilterResultSkeleton';
import { INFINITE_SCROLL_OFFSET_DESKTOP, INFINITE_SCROLL_OFFSET_MOBILE } from './constants';
import { InfiniteScrollContainerStyled, ProductCardStyled, ProductCardWrapperStyled, } from './styled';
export function FilterResults(props) {
    const { productListData, isRightToLeft = false, pdpPageUrl = '', isInAuthor = false, daysToShowNew, isDataExists, perPageLimitSetting, onScrollReachEnd, updateItemsRef, isLoaded, isInEditor, } = props;
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const rootLanguage = useSelector(getRootLang);
    const { isLiked, onLike } = useWishlist();
    if (!productListData) {
        return null;
    }
    if (!isLoaded && !isInEditor) {
        return React.createElement(FilterResultSkeleton, { currentPerPageValue: perPageLimitSetting });
    }
    const iconSize = isMobileView ? ICON_SIZE.xxl : ICON_SIZE.xxxxxl;
    if (isDataExists && productListData.length === 0) {
        return (React.createElement(FlexWrapper, { isFullWidth: true, minHeight: "120px", alignItems: "center", justifyContent: "center" },
            React.createElement(InfoBlockEmptyResults, { customIcon: React.createElement(SVGIcon, { type: CartEmpty, size: iconSize }), bgColor: colorCoreWhite1000, verticalIndentTablet: "96px", verticalIndentDesktop: "184px", titleEmptyResults: t('productsGrid_noProductsFound_label'), descriptionEmptyResults: t('productsGrid_couldNotFoundProducts_hint'), isFullWidth: true })));
    }
    return (React.createElement(InfiniteScroll, { onReachEnd: onScrollReachEnd, offset: isMobileView ? INFINITE_SCROLL_OFFSET_MOBILE : INFINITE_SCROLL_OFFSET_DESKTOP, containerStyles: InfiniteScrollContainerStyled },
        React.createElement(ProductCardWrapperStyled, { flexDirection: "row", flexWrap: "wrap", gap: "24px" }, productListData.map((item, index) => {
            const id = item?.id || item?.slug || '';
            const key = buildKey(id, index);
            if (!item || !item?.variants) {
                return null;
            }
            const { name, isStock, images, embargoExternal, popularityIndex, prices, cardUrl, isLabelFromVisible, } = getProductCardData({
                itemData: item,
                path: pdpPageUrl,
                isInAuthor,
                isImageMasterVariant: false,
                isCheapestVariant: true,
            });
            const cardProps = {
                name,
                prices,
                images,
                embargoExternal,
                popularityIndex,
                isStock,
                cardUrl,
                daysToShowNew,
                isLabelFromVisible,
            };
            return (React.createElement(ProductCardStyled, { ...props, key: key, id: id, ref: (el) => {
                    if (el) {
                        updateItemsRef?.(id, {
                            current: el,
                        });
                    }
                } },
                React.createElement(AccessoriesCard, { isRightToLeft: isRightToLeft, cardProps: cardProps, language: rootLanguage, isLiked: isLiked(item), onLike: onLike(item.variants.find((v) => v.master)?.sku ?? '', cardUrl) })));
        }))));
}
